"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/cms_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSAccountServiceSaveUserMemoResponse = exports.CMSAccountServiceSaveUserMemoRequest = exports.CMSAccountServiceCreateTenantResponse = exports.CMSAccountServiceCreateTenantRequest = exports.CMSAccountServiceGetCoreFansFilterValuesResponse = exports.CMSAccountServiceGetCoreFansFilterValuesRequest = exports.CMSAccountServiceGetCoreFansByBrandIdResponse = exports.CMSAccountServiceGetCoreFansByBrandIdRequest = exports.CMSAccountServiceGetTenantByFirestoreIdResponse = exports.CMSAccountServiceGetTenantByFirestoreIdRequest = exports.CMSAccountServiceGetBrandByFirestoreIdResponse = exports.CMSAccountServiceGetBrandByFirestoreIdRequest = exports.CMSAccountServiceGetCreatorByEmailResponse = exports.CMSAccountServiceGetCreatorByEmailRequest = exports.CMSAccountServiceGetCreatorByFirestoreIdResponse = exports.CMSAccountServiceGetCreatorByFirestoreIdRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const cms_common_pb_1 = require("./cms_common_pb");
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetCreatorByFirestoreIdRequest
 */
class CMSAccountServiceGetCreatorByFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetCreatorByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetCreatorByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetCreatorByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetCreatorByFirestoreIdRequest, a, b);
    }
}
exports.CMSAccountServiceGetCreatorByFirestoreIdRequest = CMSAccountServiceGetCreatorByFirestoreIdRequest;
CMSAccountServiceGetCreatorByFirestoreIdRequest.runtime = protobuf_1.proto3;
CMSAccountServiceGetCreatorByFirestoreIdRequest.typeName = "spwn.account.v1.CMSAccountServiceGetCreatorByFirestoreIdRequest";
CMSAccountServiceGetCreatorByFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetCreatorByFirestoreIdResponse
 */
class CMSAccountServiceGetCreatorByFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetCreatorByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetCreatorByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetCreatorByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetCreatorByFirestoreIdResponse, a, b);
    }
}
exports.CMSAccountServiceGetCreatorByFirestoreIdResponse = CMSAccountServiceGetCreatorByFirestoreIdResponse;
CMSAccountServiceGetCreatorByFirestoreIdResponse.runtime = protobuf_1.proto3;
CMSAccountServiceGetCreatorByFirestoreIdResponse.typeName = "spwn.account.v1.CMSAccountServiceGetCreatorByFirestoreIdResponse";
CMSAccountServiceGetCreatorByFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "message", T: cms_common_pb_1.CMSCreator },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetCreatorByEmailRequest
 */
class CMSAccountServiceGetCreatorByEmailRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string email = 1;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetCreatorByEmailRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetCreatorByEmailRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetCreatorByEmailRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetCreatorByEmailRequest, a, b);
    }
}
exports.CMSAccountServiceGetCreatorByEmailRequest = CMSAccountServiceGetCreatorByEmailRequest;
CMSAccountServiceGetCreatorByEmailRequest.runtime = protobuf_1.proto3;
CMSAccountServiceGetCreatorByEmailRequest.typeName = "spwn.account.v1.CMSAccountServiceGetCreatorByEmailRequest";
CMSAccountServiceGetCreatorByEmailRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetCreatorByEmailResponse
 */
class CMSAccountServiceGetCreatorByEmailResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetCreatorByEmailResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetCreatorByEmailResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetCreatorByEmailResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetCreatorByEmailResponse, a, b);
    }
}
exports.CMSAccountServiceGetCreatorByEmailResponse = CMSAccountServiceGetCreatorByEmailResponse;
CMSAccountServiceGetCreatorByEmailResponse.runtime = protobuf_1.proto3;
CMSAccountServiceGetCreatorByEmailResponse.typeName = "spwn.account.v1.CMSAccountServiceGetCreatorByEmailResponse";
CMSAccountServiceGetCreatorByEmailResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "creator", kind: "message", T: cms_common_pb_1.CMSCreator },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetBrandByFirestoreIdRequest
 */
class CMSAccountServiceGetBrandByFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_firestore_id = 1;
         */
        this.brandFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetBrandByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetBrandByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetBrandByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetBrandByFirestoreIdRequest, a, b);
    }
}
exports.CMSAccountServiceGetBrandByFirestoreIdRequest = CMSAccountServiceGetBrandByFirestoreIdRequest;
CMSAccountServiceGetBrandByFirestoreIdRequest.runtime = protobuf_1.proto3;
CMSAccountServiceGetBrandByFirestoreIdRequest.typeName = "spwn.account.v1.CMSAccountServiceGetBrandByFirestoreIdRequest";
CMSAccountServiceGetBrandByFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetBrandByFirestoreIdResponse
 */
class CMSAccountServiceGetBrandByFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetBrandByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetBrandByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetBrandByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetBrandByFirestoreIdResponse, a, b);
    }
}
exports.CMSAccountServiceGetBrandByFirestoreIdResponse = CMSAccountServiceGetBrandByFirestoreIdResponse;
CMSAccountServiceGetBrandByFirestoreIdResponse.runtime = protobuf_1.proto3;
CMSAccountServiceGetBrandByFirestoreIdResponse.typeName = "spwn.account.v1.CMSAccountServiceGetBrandByFirestoreIdResponse";
CMSAccountServiceGetBrandByFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "message", T: cms_common_pb_1.CMSBrand },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetTenantByFirestoreIdRequest
 */
class CMSAccountServiceGetTenantByFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_firestore_id = 1;
         */
        this.tenantFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetTenantByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetTenantByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetTenantByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetTenantByFirestoreIdRequest, a, b);
    }
}
exports.CMSAccountServiceGetTenantByFirestoreIdRequest = CMSAccountServiceGetTenantByFirestoreIdRequest;
CMSAccountServiceGetTenantByFirestoreIdRequest.runtime = protobuf_1.proto3;
CMSAccountServiceGetTenantByFirestoreIdRequest.typeName = "spwn.account.v1.CMSAccountServiceGetTenantByFirestoreIdRequest";
CMSAccountServiceGetTenantByFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetTenantByFirestoreIdResponse
 */
class CMSAccountServiceGetTenantByFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetTenantByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetTenantByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetTenantByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetTenantByFirestoreIdResponse, a, b);
    }
}
exports.CMSAccountServiceGetTenantByFirestoreIdResponse = CMSAccountServiceGetTenantByFirestoreIdResponse;
CMSAccountServiceGetTenantByFirestoreIdResponse.runtime = protobuf_1.proto3;
CMSAccountServiceGetTenantByFirestoreIdResponse.typeName = "spwn.account.v1.CMSAccountServiceGetTenantByFirestoreIdResponse";
CMSAccountServiceGetTenantByFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant", kind: "message", T: cms_common_pb_1.CMSTenant },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetCoreFansByBrandIdRequest
 */
class CMSAccountServiceGetCoreFansByBrandIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 page_number = 1;
         */
        this.pageNumber = 0;
        /**
         * @generated from field: repeated string filter_plans_ids = 2;
         */
        this.filterPlansIds = [];
        /**
         * @generated from field: repeated string filter_goods_ids = 3;
         */
        this.filterGoodsIds = [];
        /**
         * @generated from field: repeated string filter_event_ids = 4;
         */
        this.filterEventIds = [];
        /**
         * @generated from field: string filter_plan_period = 5;
         */
        this.filterPlanPeriod = "";
        /**
         * @generated from field: spwn.account.v1.CMSCoreFansPlanFilterCondition filter_plan_period_condition = 6;
         */
        this.filterPlanPeriodCondition = cms_common_pb_1.CMSCoreFansPlanFilterCondition.CMS_CORE_FANS_PLAN_FILTER_CONDITION_UNSPECIFIED;
        /**
         * @generated from field: spwn.account.v1.CMSAccountCoreFansListDurationOrder duration_order = 7;
         */
        this.durationOrder = cms_common_pb_1.CMSAccountCoreFansListDurationOrder.CMS_ACCOUNT_CORE_FANS_LIST_DURATION_ORDER_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetCoreFansByBrandIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetCoreFansByBrandIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetCoreFansByBrandIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetCoreFansByBrandIdRequest, a, b);
    }
}
exports.CMSAccountServiceGetCoreFansByBrandIdRequest = CMSAccountServiceGetCoreFansByBrandIdRequest;
CMSAccountServiceGetCoreFansByBrandIdRequest.runtime = protobuf_1.proto3;
CMSAccountServiceGetCoreFansByBrandIdRequest.typeName = "spwn.account.v1.CMSAccountServiceGetCoreFansByBrandIdRequest";
CMSAccountServiceGetCoreFansByBrandIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "filter_plans_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "filter_goods_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "filter_event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "filter_plan_period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "filter_plan_period_condition", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSCoreFansPlanFilterCondition) },
    { no: 7, name: "duration_order", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSAccountCoreFansListDurationOrder) },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetCoreFansByBrandIdResponse
 */
class CMSAccountServiceGetCoreFansByBrandIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.CMSAccountCoreFan core_fans = 1;
         */
        this.coreFans = [];
        /**
         * @generated from field: int32 total_pages = 2;
         */
        this.totalPages = 0;
        /**
         * @generated from field: int32 total_count = 3;
         */
        this.totalCount = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetCoreFansByBrandIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetCoreFansByBrandIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetCoreFansByBrandIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetCoreFansByBrandIdResponse, a, b);
    }
}
exports.CMSAccountServiceGetCoreFansByBrandIdResponse = CMSAccountServiceGetCoreFansByBrandIdResponse;
CMSAccountServiceGetCoreFansByBrandIdResponse.runtime = protobuf_1.proto3;
CMSAccountServiceGetCoreFansByBrandIdResponse.typeName = "spwn.account.v1.CMSAccountServiceGetCoreFansByBrandIdResponse";
CMSAccountServiceGetCoreFansByBrandIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "core_fans", kind: "message", T: cms_common_pb_1.CMSAccountCoreFan, repeated: true },
    { no: 2, name: "total_pages", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetCoreFansFilterValuesRequest
 */
class CMSAccountServiceGetCoreFansFilterValuesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetCoreFansFilterValuesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetCoreFansFilterValuesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetCoreFansFilterValuesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetCoreFansFilterValuesRequest, a, b);
    }
}
exports.CMSAccountServiceGetCoreFansFilterValuesRequest = CMSAccountServiceGetCoreFansFilterValuesRequest;
CMSAccountServiceGetCoreFansFilterValuesRequest.runtime = protobuf_1.proto3;
CMSAccountServiceGetCoreFansFilterValuesRequest.typeName = "spwn.account.v1.CMSAccountServiceGetCoreFansFilterValuesRequest";
CMSAccountServiceGetCoreFansFilterValuesRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceGetCoreFansFilterValuesResponse
 */
class CMSAccountServiceGetCoreFansFilterValuesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 加入プラン一覧
         *
         * @generated from field: repeated spwn.account.v1.CMSAccountPlan plan_list = 1;
         */
        this.planList = [];
        /**
         * 購入グッズ一覧
         *
         * @generated from field: repeated spwn.account.v1.CMSAccountGoods goods_list = 2;
         */
        this.goodsList = [];
        /**
         * イベント一覧
         *
         * @generated from field: repeated spwn.account.v1.CMSAccountEvents event_list = 3;
         */
        this.eventList = [];
        /**
         * 最大プラン継続月数
         *
         * @generated from field: int32 max_plan_period = 4;
         */
        this.maxPlanPeriod = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceGetCoreFansFilterValuesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceGetCoreFansFilterValuesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceGetCoreFansFilterValuesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceGetCoreFansFilterValuesResponse, a, b);
    }
}
exports.CMSAccountServiceGetCoreFansFilterValuesResponse = CMSAccountServiceGetCoreFansFilterValuesResponse;
CMSAccountServiceGetCoreFansFilterValuesResponse.runtime = protobuf_1.proto3;
CMSAccountServiceGetCoreFansFilterValuesResponse.typeName = "spwn.account.v1.CMSAccountServiceGetCoreFansFilterValuesResponse";
CMSAccountServiceGetCoreFansFilterValuesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "plan_list", kind: "message", T: cms_common_pb_1.CMSAccountPlan, repeated: true },
    { no: 2, name: "goods_list", kind: "message", T: cms_common_pb_1.CMSAccountGoods, repeated: true },
    { no: 3, name: "event_list", kind: "message", T: cms_common_pb_1.CMSAccountEvents, repeated: true },
    { no: 4, name: "max_plan_period", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * テナント登録
 *
 * @generated from message spwn.account.v1.CMSAccountServiceCreateTenantRequest
 */
class CMSAccountServiceCreateTenantRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * テナント名
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * 登録区分
         *
         * @generated from field: spwn.account.v1.CMSTenantType type = 2;
         */
        this.type = cms_common_pb_1.CMSTenantType.CMS_TENANT_TYPE_UNSPECIFIED;
        /**
         * 希望URL
         *
         * @generated from field: string brand_slug = 3;
         */
        this.brandSlug = "";
        /**
         * 代表者名(姓)
         *
         * @generated from field: string representative_last_name = 4;
         */
        this.representativeLastName = "";
        /**
         * 代表者名(名)
         *
         * @generated from field: string representative_first_name = 5;
         */
        this.representativeFirstName = "";
        /**
         * 個別情報（個人または法人）
         *
         * @generated from oneof spwn.account.v1.CMSAccountServiceCreateTenantRequest.specific_info
         */
        this.specificInfo = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceCreateTenantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceCreateTenantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceCreateTenantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceCreateTenantRequest, a, b);
    }
}
exports.CMSAccountServiceCreateTenantRequest = CMSAccountServiceCreateTenantRequest;
CMSAccountServiceCreateTenantRequest.runtime = protobuf_1.proto3;
CMSAccountServiceCreateTenantRequest.typeName = "spwn.account.v1.CMSAccountServiceCreateTenantRequest";
CMSAccountServiceCreateTenantRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSTenantType) },
    { no: 3, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "representative_last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "representative_first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "individual_info", kind: "message", T: cms_common_pb_1.IndividualTenantInfo, oneof: "specific_info" },
    { no: 7, name: "corporation_info", kind: "message", T: cms_common_pb_1.CorporationTenantInfo, oneof: "specific_info" },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceCreateTenantResponse
 */
class CMSAccountServiceCreateTenantResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceCreateTenantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceCreateTenantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceCreateTenantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceCreateTenantResponse, a, b);
    }
}
exports.CMSAccountServiceCreateTenantResponse = CMSAccountServiceCreateTenantResponse;
CMSAccountServiceCreateTenantResponse.runtime = protobuf_1.proto3;
CMSAccountServiceCreateTenantResponse.typeName = "spwn.account.v1.CMSAccountServiceCreateTenantResponse";
CMSAccountServiceCreateTenantResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_core", kind: "message", T: cms_common_pb_1.CMSTenantCore },
    { no: 2, name: "brand_core", kind: "message", T: cms_common_pb_1.CMSBrandCore },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceSaveUserMemoRequest
 */
class CMSAccountServiceSaveUserMemoRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string memo = 2;
         */
        this.memo = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceSaveUserMemoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceSaveUserMemoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceSaveUserMemoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceSaveUserMemoRequest, a, b);
    }
}
exports.CMSAccountServiceSaveUserMemoRequest = CMSAccountServiceSaveUserMemoRequest;
CMSAccountServiceSaveUserMemoRequest.runtime = protobuf_1.proto3;
CMSAccountServiceSaveUserMemoRequest.typeName = "spwn.account.v1.CMSAccountServiceSaveUserMemoRequest";
CMSAccountServiceSaveUserMemoRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "memo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.CMSAccountServiceSaveUserMemoResponse
 */
class CMSAccountServiceSaveUserMemoResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSAccountServiceSaveUserMemoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSAccountServiceSaveUserMemoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSAccountServiceSaveUserMemoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSAccountServiceSaveUserMemoResponse, a, b);
    }
}
exports.CMSAccountServiceSaveUserMemoResponse = CMSAccountServiceSaveUserMemoResponse;
CMSAccountServiceSaveUserMemoResponse.runtime = protobuf_1.proto3;
CMSAccountServiceSaveUserMemoResponse.typeName = "spwn.account.v1.CMSAccountServiceSaveUserMemoResponse";
CMSAccountServiceSaveUserMemoResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
//# sourceMappingURL=cms_service_pb.js.map